import React from "react";

export const isFunction = (value: any): value is Function => {
    return typeof value === "function";
};

const dateOptions: Intl.DateTimeFormatOptions = { day: "2-digit", month: "2-digit", year: "numeric" };
const timeOptions: Intl.DateTimeFormatOptions = { hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" };

type NullableDate = Date | string | number | null | undefined;

export const dataFormatters: Record<string, (date: NullableDate) => string | null> = {
    "date": (date) => date ? new Date(date).toLocaleDateString() : null,
    "datetime": (date) => date ? new Date(date).toLocaleString("en-US") : null,
    "datetime_en": (date) => {
        if (!date) return null;
        const dateObj = new Date(date);
        return dateObj.toLocaleDateString("en", dateOptions) + " " + dateObj.toLocaleTimeString("en", timeOptions);
    }
};


export const dateFixMiliseconds = (date: NullableDate): NullableDate => {
    if (!date) return date;
    const dateObj = new Date(date);

    return dateObj.toISOString().split(".")[0];
};


export const formatLocalDateNoMs = (date: Date): NullableDate => {
    const pad = (n: number) => n.toString().padStart(2, "0");
    return [
        date.getFullYear(),
        "-", pad(date.getMonth() + 1),
        "-", pad(date.getDate()),
        "T", pad(date.getHours()),
        ":", pad(date.getMinutes()),
        ":", pad(date.getSeconds())
    ].join("");
};

export const formatDateToLocalISOString = (date: Date): string => {
    const pad = (n: number) => n.toString().padStart(2, "0");

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

export const handleDownload = async (file_name = "file", blob: Blob) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = file_name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

export const cutEmptyValues = (obj: Record<string, any>) => {
    return Object.keys(obj).reduce((result: Record<string, any>, key: string) => {
        if (obj[key]) {
            result[key] = obj[key];
        }
        return result;
    }, {});
};


export const parseDateWithMicrosecondsToSeconds = (dateStr: string = ""): number => {
    if (!dateStr) {
        return 0;
    }
    
    const [datePart, timePart] = dateStr.split("T");
    const [time, fractionalRaw = "0"] = timePart.split(".");
    const fractional = fractionalRaw.padEnd(6, "0").slice(0, 6);

    const baseIso = `${datePart}T${time}`;
    const date = new Date(baseIso);

    const micros = parseInt(fractional, 10);
    const secondsWithMicros = date.getTime() / 1000 + micros / 1_000_000;

    return secondsWithMicros;
};

export const validationHasErrors = (valid: any): boolean => {
    if (!valid || typeof valid !== "object") return false;

    return Object.values(valid).some((value: any) => {
        return value.hasError;
    });
};

export const isObjectsEqual = (a: Record<string, any>, b: Record<string, any>): boolean => {
    return JSON.stringify(a) === JSON.stringify(b);
};